export interface KanbanTableI {
    id?: number;
    select?: boolean;
    favorite: boolean;
    img: string;
    name: string;
    item: string;
    supplier: string;
    expiration: string;
    source: string;
    inHouseID: string;
 }

 export interface SearchFilterI {
  filterName: string;
  filterValue: string;
}

export interface SearchCardI {
  id: string;
  select?: boolean;
  title: string;
  filterList: SearchFilterI[];
  userId?: string;
  module?:string;
  description?: string;
  isTab?: boolean;
  isShared: boolean;
  isHide: boolean;
  order: number;
  editPermission?: boolean;
}
